import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: false
}

const sideNavActionsSlice = createSlice({
    name: 'sideNav',
    initialState,
    reducers: {
        toggleSideNav: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { toggleSideNav } = sideNavActionsSlice.actions;
export default sideNavActionsSlice.reducer